
import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

window.addEventListener('frame-ready', init)

function init() {
    let links = Array.from(document.querySelectorAll('.smooth-scroll'))

    if(links.length > 0) {
        links.forEach(link => {
            let href = link.getAttribute('href').split('#')
            let id = `#${href[href.length - 1]}`

            if(document.querySelector(id)) {
                link.addEventListener('click', e => {
                    e.preventDefault()
                    gsap.to(window, { duration: .5, scrollTo: { y: id, offset: 50 }, ease: 'power2'})
                })
            } else {
                throw 'that section doesn\'t exist'
            }
        })
    }
}
